/**
 * talk·point — <tp-variant-selector-v2>  (geführte Kaskade)
 * Refurbished-PDP hat KEINE echten Shopify-Varianten: jede Kombination aus
 * Speicher × Farbe × Zustand ist ein EIGENES Produkt, gruppiert über den Tag
 * Basename_<Name>. Diese Component lädt die Geschwister-Produkte asynchron per
 * Storefront-GraphQL (die PDP rendert sofort, der Selector füllt sich nach) und
 * baut daraus die Auswahl: Zustand-/Speicher-Kacheln + Farbkreise mit Aufpreis
 * und Verfügbarkeits-Status je Option. Klick = Redirect auf das Match-Produkt
 * (kein In-Page-Variantenwechsel -> sauberes SEO, je Kombi eigene URL).
 *
 * Unterschied zu v1 (tp-variant-selector.js): geführter Funnel
 *   Zustand → Speicher → Farbe. Jede Stufe graut die Werte aus, die mit der
 *   bereits gewählten VORGELAGERTEN Auswahl nicht kombinierbar (und verfügbar)
 *   sind ("ausgegraut an Ort"), und der Klick auf eine ausgegraute Option ist
 *   inert. Ein vorgelagerter Wechsel behält so viel wie möglich (lockert von
 *   hinten) statt heimlich auf das günstigste Produkt zu springen.
 *
 * Bewusst import-frei (kein Modul).
 *
 * Attribute (vom Liquid gesetzt):
 *   data-basename       Basename_<Name>-Tag des aktuellen Produkts (Pflicht)
 *   data-handle         Handle des aktuellen Produkts (für Vorauswahl)
 *   data-token          Public Storefront-Access-Token (settings.storefront_token)
 *   data-api-version    z. B. 2025-07
 */
(function () {
  if (customElements.get('tp-variant-selector-v2')) return;

  // Funnel-Reihenfolge: Stufe N graut nur anhand der Stufen davor (Upstream).
  var FUNNEL = ['Zustand_', 'Speicher_', 'Farbe_'];

  // Gepflegte Marken-Farbpalette (aus v1 faceted-filter-group.liquid), gedämpft.
  // Keys kleingeschrieben; de + gängige en/Refurb-Aliase. Fallback: #888.
  var COLOR_MAP = {
    schwarz: '#1f2020', black: '#1f2020',
    weiß: '#f3f3ef', weiss: '#f3f3ef', white: '#f3f3ef',
    blau: '#3c5a78', blue: '#3c5a78', sierrablau: '#9fb6cf', pazifikblau: '#2f5a6e',
    grün: '#3f6f52', gruen: '#3f6f52', green: '#3f6f52', 'nachtgrün': '#33453d', alpingrün: '#43564a',
    gelb: '#f2d574', yellow: '#f2d574',
    pink: '#f4c4ce', 'rosé': '#f4c4ce', rose: '#f4c4ce', rosa: '#f4c4ce',
    rot: '#b53a3a', red: '#b53a3a', '(product) red': '#b53a3a', '(product)red': '#b53a3a', koralle: '#ff7f6b',
    lila: '#7b6aa6', violett: '#7b6aa6', purple: '#7b6aa6',
    orange: '#e08a3c',
    gold: '#c9a96a', 'rosé gold': '#e6c0a8', 'roségold': '#e6c0a8', roségold: '#e6c0a8',
    silber: '#cfd2d4', silver: '#cfd2d4',
    grau: '#8a8d8f', gray: '#8a8d8f', grey: '#8a8d8f',
    graphit: '#3a3a3c', spacegrau: '#52555a', 'space grau': '#52555a', 'space grey': '#52555a',
    mitternacht: '#2b2f36', midnight: '#2b2f36', polarstern: '#e8e6df', starlight: '#e8e6df',
    beige: '#d9cbb3', braun: '#6f5238', brown: '#6f5238',
    mint: '#a8d8c8', 'türkis': '#3aa6a0', tuerkis: '#3aa6a0',
    transparent: '#e9eef2', klar: '#e9eef2',
  };

  // Zustand-Tag-Wert -> Anzeige + Sortier-Rang + Badge-Klasse.
  // Robust gegen Schreibweisen: "Neuware", "A - wie neu", "B - Sehr Gut", …
  // Rang/Klasse aus dem A–D-Präfix; Neuware ohne Präfix = Rang 0.
  function capWords(s) {
    return String(s || '').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  function capFirst(s) {
    var v = String(s || '');
    return v ? v.charAt(0).toUpperCase() + v.slice(1) : v;
  }
  function condInfo(value) {
    var v = (value || '').trim();
    if (/^neuware$/i.test(v)) return { label: 'Neu', order: 0, cls: 'neuware' };
    var m = v.match(/^([A-D])\s*-\s*(.+)$/i);
    if (m) {
      var letter = m[1].toUpperCase();
      return { label: capWords(m[2]), order: { A: 1, B: 2, C: 3, D: 4 }[letter], cls: letter.toLowerCase() };
    }
    return { label: capWords(v) || v, order: 99, cls: 'x' };
  }

  // Kanonische Grade eines Zustand-Tags: 'Neuware' oder Buchstabe A–D.
  function gradeKey(value) {
    var v = (value || '').trim();
    if (/^neuware$/i.test(v)) return 'Neuware';
    var m = v.match(/^([A-D])\b/i);
    return m ? m[1].toUpperCase() : v.toUpperCase();
  }

  // Feste Zustands-Leiter: wird IMMER komplett angezeigt, auch wenn ein Grad
  // im Sortiment fehlt (dann "nicht verfügbar" + Akku-Hinweis, inert).
  var CANON_GRADES = [
    { key: 'Neuware', label: 'Neu',      order: 0 },
    { key: 'A',       label: 'Wie Neu',  order: 1 },
    { key: 'B',       label: 'Sehr Gut', order: 2 },
    { key: 'C',       label: 'Gut',      order: 3 },
  ];

  // Akku-Hinweis je Grad (3. Zeile der Kachel). Werte 1:1 aus der Zustands-
  // Tabelle (sections/tp-conditions.liquid) -> Buybox + Vergleich konsistent.
  var BATTERY_HINT = {
    Neuware: 'Neu',
    A: 'Akku ≥ 95 %',
    B: 'Akku ≥ 90 %',
    C: 'Akku ≥ 85 %',
  };

  // Apple-CPO (Certified Pre-Owned, unregistriert, Plan 0126): bleibt Grad
  // Neuware, nur die Kachel heißt „Neu · CPO" statt „Neu" (Vorschlag 2). Gleicher Tag wie snippets/tp-cpo.liquid.
  var CPO_LABEL = 'Neu · CPO';
  function isCpo(product) {
    return ((product && product.tags) || []).indexOf('CPO') !== -1;
  }

  // Unscharfe Zuordnung für Marketing-Freitext, den COLOR_MAP nicht exakt kennt
  // ("Midnight Black", "Awesome Graphite", "Edelstahl", "Tiefblau", …). Spiegelt
  // 1:1 die Kette aus snippets/tp-variant-selector-skeleton.liquid -> Server-
  // Skeleton und JS malen denselben Kreis (kein Farbsprung beim Hydrieren).
  // Reihenfolge = Priorität: dunkel/hell vor Buntfarben, sonst gewinnt bei
  // "Midnight Black" das "night" nicht gegen "black".
  var LOOSE = [
    [['schwarz', 'black', 'obsidian', 'midnight', 'mitternacht', 'onyx'], '#1f2020'],
    [['weiß', 'weiss', 'white', 'polarstern', 'starlight', 'cream'], '#f3f3ef'],
    [['graphit', 'grafit', 'graphite', 'space', 'anthrazit', 'basalt', 'grau', 'gray', 'grey'], '#52555a'],
    [['silber', 'silver', 'titan', 'edelstahl', 'alumin', 'platin', 'chrom'], '#cfd2d4'],
    [['blau', 'blue', 'navy', 'cobalt', 'indigo', 'ocean', 'sierra'], '#3c5a78'],
    [['grün', 'gruen', 'green', 'mint', 'lime', 'jade'], '#3f6f52'],
    [['rot', 'red'], '#b53a3a'],
    [['gelb', 'yellow', 'amber'], '#f2d574'],
    [['violet', 'violett', 'purple', 'lila', 'lavend'], '#7b6aa6'],
    [['pink', 'rosa', 'rosé', 'rose'], '#f4c4ce'],
    [['gold'], '#c9a96a'],
    [['beige', 'braun', 'brown', 'sand'], '#d9cbb3'],
    [['orange', 'koralle'], '#e08a3c'],
    [['transparent', 'klar'], '#e9eef2'],
  ];
  function looseHex(name) {
    var n = String(name || '').toLowerCase().trim();
    if (!n) return '';
    for (var i = 0; i < LOOSE.length; i++) {
      for (var j = 0; j < LOOSE[i][0].length; j++) {
        if (n.indexOf(LOOSE[i][0][j]) !== -1) return LOOSE[i][1];
      }
    }
    return '';
  }

  // BFARBE_-Werte, die als Label unschön sind (kontrolliertes Vokabular, 18 Werte).
  var BASE_ALIAS = {
    silberfarben: 'Silber', goldfarben: 'Gold', bunt: 'Mehrfarbig', natur: 'Naturfarben',
  };

  // Swatch-Farbe. Kette: exakter Marketing-Treffer (spezifischste Nuance, z. B.
  // "Sierrablau") -> BFARBE_ (kuratiert, deckt 2/3 des Sortiments) -> unscharfer
  // Marketing-Treffer -> Grau. Hebt die #888-Quote von 32,4 % auf < 5 %.
  function colorHex(name, baseName) {
    var exact = COLOR_MAP[String(name || '').toLowerCase().trim()];
    if (exact) return exact;
    var base = String(baseName || '').toLowerCase().trim();
    if (base && COLOR_MAP[base]) return COLOR_MAP[base];
    return looseHex(name) || looseHex(base) || '#888';
  }

  // Anzeige-Label einer Farbe: bevorzugt die Basisfarbe ("Rot" statt
  // "(PRODUCT) RED") — aber nur, wenn sie in dieser Familie eindeutig ist.
  // Kollidiert sie (S25 Ultra "Titanium Jetblack" vs. "Titanium Black" -> beide
  // BFARBE_schwarz), bleibt der Marketing-Name, sonst wären zwei reale Produkte
  // ununterscheidbar.
  function colorLabel(name, baseName, baseIsUnique) {
    var base = String(baseName || '').toLowerCase().trim();
    if (!base || !baseIsUnique) return name;
    return BASE_ALIAS[base] || capWords(base);
  }

  // ---- Tag-Helfer --------------------------------------------------------
  function tagVal(product, prefix) {
    var t = (product.tags || []).find(function (x) { return x.indexOf(prefix) === 0; });
    return t ? t.slice(prefix.length) : '';
  }
  // Tag-Werte kommen aus dem Feed und sind im Casing inkonsistent ("Schwarz" vs.
  // "schwarz", 38 Familien betroffen) -> ALLE Wertvergleiche laufen normalisiert,
  // sonst erscheint dieselbe Farbe zweimal bzw. ein Geschwister wird nicht gefunden.
  function normVal(v) {
    return String(v || '').toLowerCase().trim();
  }
  function eqVal(a, b) {
    return normVal(a) === normVal(b);
  }
  function uniqueVals(products, prefix) {
    var seen = {};
    var out = [];
    products.forEach(function (p) {
      var v = tagVal(p, prefix);
      var k = normVal(v);
      if (v && !seen[k]) { seen[k] = 1; out.push(v); } // erste Schreibweise gewinnt
    });
    return out;
  }
  // Basisfarbe (BFARBE_) zu einem Marketing-Farbwert, aus den Geschwistern gelesen.
  function baseColorOf(products, value) {
    var hit = products.filter(function (p) { return eqVal(tagVal(p, 'Farbe_'), value) && tagVal(p, 'BFARBE_'); })[0];
    return hit ? tagVal(hit, 'BFARBE_') : '';
  }
  // Speicher-Anzeige: reine Zahl aus dem Tag bekommt die Einheit ("256" ->
  // "256 GB"), fertige Angaben bleiben, wie sie im Tag stehen ("1 TB").
  // Eine Quelle für Speicher-Pille UND Abweichungs-Zusatz auf der Kachel.
  function storageLabel(value) {
    var v = String(value || '').trim();
    if (!v) return '';
    return /^\d+$/.test(v) ? v + ' GB' : v;
  }

  function priceOf(product) {
    var e = product.variants && product.variants.edges && product.variants.edges[0];
    return e ? parseFloat(e.node.price.amount) : NaN;
  }
  function currencyOf(product) {
    var e = product.variants && product.variants.edges && product.variants.edges[0];
    return e ? e.node.price.currencyCode : 'EUR';
  }

  class TpVariantSelectorV2 extends HTMLElement {
    connectedCallback() {
      // bfcache-Rückkehr (Zurück-Button): Switching-Feedback wieder abräumen,
      // sonst klebt der Spinner an der Kachel.
      window.addEventListener('pageshow', this.clearSwitching.bind(this));

      this.basename = this.getAttribute('data-basename') || '';
      this.handle = this.getAttribute('data-handle') || '';
      this.token = this.getAttribute('data-token') || '';
      this.apiVersion = this.getAttribute('data-api-version') || '2025-07';
      this.condition = (this.getAttribute('data-condition') || '').toUpperCase();
      // Wird die Akkugüte bei diesem Gerätetyp überhaupt nach Zustand
      // zugesichert? Entscheidung trifft Liquid (snippets/tp-akku-relevant),
      // damit Kacheln und Zustands-Tabelle dieselbe Quelle haben. Fehlt das
      // Attribut (alte Templates), bleibt das bisherige Verhalten.
      this.akku = this.getAttribute('data-akku') !== 'false';

      // Ohne Variantenfamilie (kein Basename), aber mit Gebraucht-Zustand:
      // nur die Zustandsleiste rendern (kein Fetch, kein Farb-/Speicher-Chooser).
      if (!this.basename || !this.token) {
        if (this.condition && this.condition !== 'N') { this.renderConditionOnly(); }
        else { this.hidden = true; }
        return;
      }

      // Warm-Cache (Navigation innerhalb der Familie): sofort echt rendern und
      // damit das Server-Skeleton in einem Rutsch ersetzen — kein Flash.
      var cached = this.readCache();
      if (cached && cached.length && this.setupFrom(cached)) { this.render(); return; }

      // Kalt: das serverseitig gerenderte Skeleton STEHEN LASSEN (volle Höhe ist
      // schon reserviert). Nur falls das Element wider Erwarten leer ist (Snippet
      // nicht gerendert), das JS-Fallback-Skeleton bauen.
      if (this.childElementCount === 0) this.renderSkeleton();
      this.load().then(function (products) {
        if (!this.setupFrom(products)) { this.hidden = true; return; }
        this.render();
      }.bind(this)).catch(function (e) {
        console.warn('[tp-variant-selector-v2]', e);
        this.hidden = true;
      }.bind(this));
    }

    // Liest den Geschwister-Cache (gleiche Quelle wie load()).
    readCache() {
      try { var c = sessionStorage.getItem('tpvs:' + this.basename); return c ? JSON.parse(c) : null; }
      catch (e) { return null; }
    }

    // Setzt products/cur/curPrice/currency/fmt aus einer Produktliste. false bei leer.
    setupFrom(products) {
      if (!products || !products.length) return false;
      this.products = products;
      this.cur = products.filter(function (p) { return p.handle === this.handle; }.bind(this))[0] || null;
      this.curPrice = this.cur ? priceOf(this.cur) : Math.min.apply(null, products.map(priceOf));
      this.currency = currencyOf(this.cur || products[0]);
      this.fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.currency });
      return true;
    }

    // ---- Nur-Zustand-Modus (Einzelprodukt ohne Variantenfamilie) ---------
    // Synthetisiert das aktuelle Produkt als einzigen "Treffer", damit render()
    // die Zustandsleiste mit der aktuellen Stufe zeigt. Farbe/Speicher bleiben
    // leer -> werden nicht gerendert. Andere Stufen = "nicht verfügbar".
    renderConditionOnly() {
      var currency = this.getAttribute('data-currency') || 'EUR';
      var price = parseFloat(this.getAttribute('data-price') || '0') / 100; // Cent -> Euro
      var available = this.getAttribute('data-available') !== 'false';
      var synthetic = {
        handle: this.handle,
        tags: ['Zustand_' + this.condition], // gradeKey() -> N/A/B/C/D
        availableForSale: available,
        variants: { edges: [{ node: { price: { amount: String(price), currencyCode: currency } } }] },
      };
      this.products = [synthetic];
      this.cur = synthetic;
      this.curPrice = price;
      this.currency = currency;
      this.fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });
      this.render();
    }

    // ---- Daten laden (Storefront-GraphQL + sessionStorage-Cache) ---------
    load() {
      var cacheKey = 'tpvs:' + this.basename;
      try {
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) return Promise.resolve(JSON.parse(cached));
      } catch (e) {}

      var query =
        'query($q: String!){products(first:100,query:$q){edges{node{' +
        'id title handle tags availableForSale ' +
        'variants(first:1){edges{node{sku quantityAvailable price{amount currencyCode}}}}' +
        '}}}}';

      var self = this;
      return fetch('/api/' + this.apiVersion + '/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.token,
        },
        body: JSON.stringify({ query: query, variables: { q: '"' + this.basename + '"' } }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var nodes = ((res.data && res.data.products && res.data.products.edges) || []).map(function (e) { return e.node; });
          // Nur echte Geschwister (Tag exakt enthalten); Verfügbarkeit NICHT
          // wegfiltern -> ausverkaufte Optionen bleiben sichtbar (als "ausverkauft").
          nodes = nodes.filter(function (n) { return (n.tags || []).indexOf(self.basename) !== -1; });
          try { sessionStorage.setItem(cacheKey, JSON.stringify(nodes)); } catch (e) {}
          return nodes;
        });
    }

    // ---- Kaskade: ist (prefix=value) mit der Upstream-Auswahl kombinierbar? --
    // Eine Option ist "möglich", wenn es ein VERFÜGBARES Produkt gibt, das diesen
    // Wert UND alle aktuell gewählten VORGELAGERTEN Dimensionen erfüllt. Liefert
    // zusätzlich den Mindestpreis + Delta des möglichen Sets (für die Anzeige).
    optMeta(prefix, value, upstreamPrefixes) {
      var self = this;
      var match = this.products.filter(function (p) {
        if (!eqVal(tagVal(p, prefix), value)) return false;
        return (upstreamPrefixes || []).every(function (up) {
          var curV = tagVal(self.cur || {}, up);
          return !curV || eqVal(tagVal(p, up), curV);
        });
      });
      var available = match.filter(function (p) { return p.availableForSale; });
      // Existiert die Kombi gar nicht mit der Upstream-Auswahl -> nichts möglich.
      var priced = available.length ? available : match;
      var min = priced.length ? Math.min.apply(null, priced.map(priceOf)) : NaN;
      return { soldOut: available.length === 0, minPrice: min, delta: min - self.curPrice };
    }

    // Für eine mit der aktuellen Auswahl NICHT kombinierbare Option: gibt es
    // trotzdem ein erreichbares Produkt (durch Lockern einer anderen Stufe)?
    // Liefert den Grund als Text ("nur mit 64 GB"). null = wirklich nicht da.
    // Ohne das laufen 25 % der Mehrfarb-PDPs in eine Sackgasse: Blau existiert,
    // ist lieferbar, war aber nicht anklickbar.
    altHint(prefix, value) {
      var target = this.resolveTarget(prefix, value);
      if (!target || !target.availableForSale || target.handle === this.handle) return null;
      var self = this;
      var parts = [];
      // Nur VORGELAGERTE Stufen nennen. Dass sich die Farbe mitändert, wenn man
      // den Speicher wechselt, ist im Funnel erwartet und würde den Hinweis nur
      // zumüllen ("256 GB · nur mit Zustand Neu · schwarz").
      this.upstreamOf(prefix).forEach(function (pre) {
        var curV = tagVal(self.cur || {}, pre);
        var newV = tagVal(target, pre);
        if (!curV || !newV || eqVal(curV, newV)) return;
        if (pre === 'Zustand_') parts.push('Zustand ' + condInfo(newV).label);
        else parts.push(/^\d+$/.test(newV) ? newV + ' GB' : newV);
      });
      return { why: parts.length ? 'nur mit ' + parts.join(' · ') : 'andere Ausführung', handle: target.handle };
    }

    // Anzeige-Label einer Farbe in DIESER Familie — dieselbe Regel wie die
    // Farbreihe unten (Basisfarbe aus BFARBE_, wenn sie eindeutig ist, sonst
    // der Marketing-Name). Damit heißt eine Farbe auf einem Bildschirm nicht
    // zweimal anders: die Kachel sagt „in Rosa", der Kreis darunter auch.
    colorLabelOf(value) {
      if (!value) return '';
      if (!this._baseUse) {
        var self = this;
        var use = {};
        uniqueVals(this.products, 'Farbe_').forEach(function (v) {
          var b = normVal(baseColorOf(self.products, v));
          if (b) use[b] = (use[b] || 0) + 1;
        });
        this._baseUse = use;
      }
      var base = baseColorOf(this.products, value);
      return colorLabel(value, base, this._baseUse[normVal(base)] === 1);
    }

    // ---- Abweichung des Klickziels in Worten ----------------------------
    // „ab" sagt nur, dass es billiger nicht geht — nicht, WARUM der Preis nicht
    // für das Gerät gilt, das gerade auf dem Schirm ist. Die abweichende
    // Eigenschaft zu nennen beantwortet das und ist zugleich die Vorwarnung für
    // den Klick. Wortlaut ausschließlich aus den Tags (Speicher_, Farbe_/BFARBE_),
    // nichts erfunden, nichts umbenannt.
    //   Fall B (nur Farbe)     -> „in Mitternacht"
    //   Fall C (nur Speicher)  -> „128 GB"
    //   beides (gemessen 108 von 450 abweichenden Kacheln = 24 %) -> „128 GB in Rosa"
    // Der lange Titel ist die Vorlesefassung (visually-hidden + title): die
    // nackten zwei Wörter neben dem Preis sind für Auge und Kontext eindeutig,
    // für einen Screenreader ohne Bezug.
    // Rückgabe: { text, title } oder null (nichts benennbar).
    diffNote(target, offDims) {
      var store = offDims.indexOf('Speicher_') !== -1 ? storageLabel(tagVal(target, 'Speicher_')) : '';
      // Nur der ERSTE Buchstabe wird groß: die Farb-Tags kommen im Casing
      // inkonsistent aus dem Feed ("Schwarz" neben "schwarz", 38 Familien).
      // In der Farbreihe fällt das nicht auf, weil .lbl per CSS versalisiert —
      // auf der Kachel stünde sonst „in Weiß" neben „in schwarz". capWords wäre
      // zu viel: es würde Marketing-Schreibweisen umschreiben.
      var color = offDims.indexOf('Farbe_') !== -1 ? capFirst(this.colorLabelOf(tagVal(target, 'Farbe_'))) : '';
      var what = store && color ? store + ' in ' + color : (store || color);
      if (!what) return null;
      return {
        text: store ? what : 'in ' + color,
        title: 'Preis gilt für ' + what,
      };
    }

    // ---- Preis einer Zustands-Kachel ------------------------------------
    // Die Kachel beantwortet „was kostet MEIN Gerät in diesem Zustand?".
    // Bis 09/2026 stand hier das Minimum über ALLE Speicher und Farben des
    // Grades — auf der 256-GB-PDP zeigte die markierte Kachel darum den
    // 128-GB-Preis und widersprach dem großen Preis direkt darüber.
    //
    // Regel jetzt:
    //   1. markierte Kachel  -> Preis des aktuellen Produkts (== großer Preis),
    //   2. andere Zustände   -> Preis des Geräts, auf dem der Klick landet
    //      (resolveTarget, gleiche Lockerungs-Kaskade Farbe -> Speicher),
    //   3. weicht dieses Gerät in Speicher/Farbe ab, benennt die Kachel die
    //      Abweichung (diffNote) — das ERSETZT das alte „ab": „ab 249,99 €
    //      · 128 GB" sagt dieselbe Einschränkung zweimal, und „128 GB" ist die
    //      präzisere Hälfte.
    //   4. „ab" bleibt genau dort, wo es nichts zu benennen gibt: das Produkt
    //      taggt die Dimension gar nicht (Smartwatch, Kopfhörer) und es bleiben
    //      mehrere Preise übrig. Dann ist „ab" die einzige ehrliche Aussage.
    // Schreibweise „ab " wie im übrigen Theme (snippets/tp-price-from.liquid).
    // Rückgabe: { price, from, note } oder null (kein Preis ermittelbar).
    condPrice(condValue, sibs, isSelected) {
      var cur = this.cur || {};
      var dims = FUNNEL.filter(function (p) { return p !== 'Zustand_'; });

      // 1. Die markierte Kachel ist per Definition das aktuelle Produkt.
      if (isSelected && this.cur && isFinite(priceOf(this.cur))) {
        return { price: priceOf(this.cur), from: false, note: null };
      }

      // 2. Zielprodukt = exakt das, auf dem der Klick landet. Damit kann die
      //    Kachel nie einen Preis versprechen, den die Zielseite nicht hält.
      var target = this.resolveTarget('Zustand_', condValue);
      var price = target ? priceOf(target) : NaN;
      if (!isFinite(price)) return null;

      // 3. In welchen gewählten Dimensionen weicht das Ziel ab? -> benennen.
      var off = dims.filter(function (pre) {
        var want = tagVal(cur, pre);
        return want && !eqVal(tagVal(target, pre), want);
      });
      var note = off.length ? this.diffNote(target, off) : null;
      if (note) return { price: price, from: false, note: note };
      // Abweichung da, aber nicht benennbar (das Ziel trägt den Tag selbst nicht,
      // z. B. ein Geschwister ohne Speicher_-Angabe) -> „ab" als Rest.
      if (off.length) return { price: price, from: true, note: null };

      // 4. Bleiben mehrere Preise übrig (Dimension am Produkt nicht getaggt)?
      var same = sibs.filter(function (p) {
        return dims.every(function (pre) {
          var want = tagVal(cur, pre);
          return !want || eqVal(tagVal(p, pre), want);
        });
      });
      var pool = same.filter(function (p) { return p.availableForSale; });
      if (!pool.length) pool = same;
      var prices = pool.map(priceOf).filter(function (n) { return isFinite(n); });
      var spread = prices.length > 1 &&
        (Math.max.apply(null, prices) - Math.min.apply(null, prices)) > 0.005;

      return { price: price, from: spread, note: null };
    }

    deltaText(delta) {
      if (!isFinite(delta) || Math.abs(delta) < 0.005) return '';
      var sign = delta > 0 ? '+' : '−';
      return sign + this.fmt.format(Math.abs(delta));
    }

    // ---- Ziel-Produkt für eine Auswahl ermitteln (Klick UND Prefetch) ----
    // "So viel wie möglich behalten": exaktes Match über alle Dimensionen; sonst
    // in Funnel-Reihenfolge VON HINTEN lockern (erst Farbe fallen lassen, dann
    // Speicher). Dabei wird der geklickte Wert IMMER beibehalten. Kein heimliches
    // Springen auf ein unverwandtes "günstigstes" Produkt.
    resolveTarget(prefix, value) {
      var self = this;
      var sel = {
        'Zustand_': tagVal(this.cur || {}, 'Zustand_'),
        'Speicher_': tagVal(this.cur || {}, 'Speicher_'),
        'Farbe_': tagVal(this.cur || {}, 'Farbe_'),
      };
      sel[prefix] = value;

      // Reihenfolge der Constraints, die wir progressiv lockern dürfen: die
      // geklickte Dimension nie, sonst von hinten (Farbe -> Speicher -> Zustand).
      var relaxOrder = FUNNEL.slice().reverse().filter(function (p) { return p !== prefix; });

      function pick(constraints) {
        var cand = self.products.filter(function (p) {
          return constraints.every(function (pre) {
            var want = sel[pre];
            return !want || eqVal(tagVal(p, pre), want);
          });
        });
        if (!cand.length) return null;
        var avail = cand.filter(function (p) { return p.availableForSale; });
        var pool = avail.length ? avail : cand;
        return pool.sort(function (a, b) { return priceOf(a) - priceOf(b); })[0];
      }

      // Start: alle Dimensionen, die gesetzt sind, als Constraint.
      var active = Object.keys(sel).filter(function (p) { return sel[p]; });
      var hit = pick(active);
      if (hit) return hit;
      // Schrittweise lockern, bis ein (möglichst passendes) Produkt übrig bleibt.
      for (var i = 0; i < relaxOrder.length; i++) {
        var drop = relaxOrder[i];
        active = active.filter(function (p) { return p !== drop; });
        hit = pick(active);
        if (hit) return hit;
      }
      return null;
    }

    // Redirect (Klick). Inkompatible/ausgegraute Optionen werden vom Click-
    // Handler abgefangen und kommen hier nicht an.
    go(prefix, value, el) {
      var target = this.resolveTarget(prefix, value);
      if (target && target.handle !== this.handle) {
        this.markSwitching(el); // Sofort-Feedback, bevor die Navigation startet
        window.location.href = '/products/' + target.handle;
      }
    }

    // Sofort-Feedback im Moment des Klicks: geklickte Kachel bekommt einen
    // Spinner, der ganze Selektor dimmt + wird inert. Wird beim bfcache-Zurück
    // (pageshow) wieder abgeräumt (siehe connectedCallback-Listener unten).
    markSwitching(el) {
      var root = this.querySelector('.tp-vs') || this;
      root.classList.add('is-switching');
      root.setAttribute('aria-busy', 'true');
      if (el) el.classList.add('is-switching');
    }
    clearSwitching() {
      var root = this.querySelector('.tp-vs') || this;
      root.classList.remove('is-switching');
      root.removeAttribute('aria-busy');
      this.querySelectorAll('.is-switching').forEach(function (n) { n.classList.remove('is-switching'); });
    }

    // Intent (Hover/Tap/Fokus): Ziel-PDP vorab rendern, damit der spätere Klick
    // quasi-instant ist. Bevorzugt Speculation-Rules-PRERENDER (rendert die Seite
    // wirklich vor); Fallback auf <link rel=prefetch> (nur Dokument-Cache) für
    // Safari/Firefox und bei aktivem Data-Saver. resolveTarget() = identisch zum
    // Klick, der Prerender trifft also exakt die Zielseite.
    speculate(prefix, value) {
      var target = this.resolveTarget(prefix, value);
      if (!target || target.handle === this.handle) return;
      var url = '/products/' + target.handle;
      if (this._seen && this._seen[url]) return;
      (this._seen = this._seen || {})[url] = 1;

      var supportsRules = typeof HTMLScriptElement !== 'undefined' &&
        typeof HTMLScriptElement.supports === 'function' && HTMLScriptElement.supports('speculationrules');
      var saveData = navigator.connection && navigator.connection.saveData;

      if (supportsRules && !saveData) {
        // Liste der letzten max. 2 URLs prerendern (Browser cappt ohnehin).
        this._spec = this._spec || [];
        this._spec.push(url);
        if (this._spec.length > 2) this._spec.shift();
        if (!this._specEl) {
          this._specEl = document.createElement('script');
          this._specEl.type = 'speculationrules';
          document.head.appendChild(this._specEl);
        }
        this._specEl.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: this._spec }] });
      } else {
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.as = 'document';
        l.href = url;
        document.head.appendChild(l);
      }
    }

    // Upstream-Prefixe einer Stufe (alles, was im Funnel davor steht).
    upstreamOf(prefix) {
      var idx = FUNNEL.indexOf(prefix);
      return idx <= 0 ? [] : FUNNEL.slice(0, idx);
    }

    // ---- Render ----------------------------------------------------------
    renderSkeleton() {
      this.innerHTML =
        '<div class="tp-vs tp-vs--loading" aria-busy="true">' +
        '<div class="tp-vs__skel tp-vs__skel--head"></div>' +
        '<div class="tp-vs__skel tp-vs__skel--grid"></div>' +
        '<div class="tp-vs__skel tp-vs__skel--row"></div>' +
        '</div>';
    }

    render() {
      var self = this;
      var colors = uniqueVals(this.products, 'Farbe_');
      var storages = uniqueVals(this.products, 'Speicher_').sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });

      // Geschwister je Grad gruppieren (für die feste Zustands-Leiter).
      var byGrade = {};
      this.products.forEach(function (p) {
        var g = gradeKey(tagVal(p, 'Zustand_'));
        if (!g) return;
        (byGrade[g] = byGrade[g] || []).push(p);
      });
      // Anzuzeigende Grade = kanonische 4 + evtl. zusätzliche (z. B. D), sortiert.
      var grades = CANON_GRADES.slice();
      Object.keys(byGrade).forEach(function (g) {
        if (!grades.some(function (x) { return x.key === g; })) {
          grades.push({ key: g, label: condInfo(byGrade[g][0] ? tagVal(byGrade[g][0], 'Zustand_') : g).label, order: 50 });
        }
      });
      grades.sort(function (a, b) { return a.order - b.order; });

      var html = '<div class="tp-vs">';

      // -- Stufe 1 · Zustand: IMMER alle Grade (Upstream = nichts) ----------
      // Greying nur über die generelle Grad-Verfügbarkeit (kein Upstream-Filter,
      // da Zustand der Funnel-Kopf ist).
      var curGrade = gradeKey(tagVal(this.cur || {}, 'Zustand_'));
      html += '<div class="tp-vs__group">' +
        '<div class="tp-pdp__cond-head"><span class="lbl">Zustand</span>' +
        '<a class="arrow" href="#tp-conditions">Was heißt das? →</a></div>' +
        '<div class="tp-pdp__cond-grid">';
      grades.forEach(function (g) {
        var sibs = byGrade[g.key] || [];
        var sel = g.key === curGrade;
        var batt = BATTERY_HINT[g.key] || '';
        // CPO und echtes Neu bleiben EIN Grad; das Label folgt dem Gerät, auf
        // dem der Klick landet (markiert = aktuelles Produkt, sonst resolveTarget).
        var cpo = g.key === 'Neuware' && sibs.length &&
          isCpo(sel ? self.cur : self.resolveTarget('Zustand_', tagVal(sibs[0], 'Zustand_')));
        var label = cpo ? CPO_LABEL : g.label;
        // Bei Neuware ist der Hinweis das Wort „Neu" — unter der Kachelüberschrift
        // „Neu" eine Zeile, die nichts sagt. Dann lieber keine dritte Zeile.
        // Dritte Zeile nur, wenn die Akkugüte bei diesem Gerätetyp nach Zustand
        // zugesichert wird (data-akku) — eine SSD hat keinen Akku, ein E-Scooter
        // einen, den wir nicht einstufen. Und nie „Neu" unter der Kachel „Neu".
        // CPO: wie „Neu" ohne dritte Zeile — der Hinweis „unregistriert" steht in der Trust-Zeile.
        var battLine = (!cpo && self.akku && batt && batt !== g.label)
          ? '<span class="cb">' + esc(batt) + '</span>' : '';
        if (!sibs.length) {
          // Grad existiert im Sortiment gar nicht -> immer sichtbar, inert.
          // Dritte Zeile: Akku-Hinweis statt „Benachrichtigen" (entfallen am
          // 12.08.2026 — es gab keinen Handler dahinter). Der Hinweis beschreibt
          // die Stufe, gilt also auch ohne Lagerbestand, und hält die Kachelhöhe.
          html += '<div class="tp-pdp__cond is-off" aria-disabled="true">' +
            '<span class="cn">' + esc(g.label) + '</span>' +
            '<span class="cp">nicht verfügbar</span>' + battLine + '</div>';
          return;
        }
        var realVal = tagVal(sibs[0], 'Zustand_'); // exakter Tag-Wert für den Redirect
        var avail = sibs.filter(function (p) { return p.availableForSale; });
        var soldOut = avail.length === 0;
        var cls = 'tp-pdp__cond' + (sel ? ' is-sel' : '') + (soldOut ? ' is-off' : '');
        // Designer-Layout: absoluter Preis (kein Delta) + Akku-Zeile.
        // Der Preis beantwortet „was kostet MEIN Gerät in diesem Zustand?"
        // (condPrice) — nicht mehr das Minimum über alle Speicher/Farben.
        var pr = self.condPrice(realVal, sibs, sel);
        // Der Zusatz steht in der PREIS-Zeile, nicht in der Akku-Zeile: er
        // qualifiziert den Preis („der gilt für 128 GB"), nicht den Zustand.
        // Neben der Akku-Angabe gelesen wäre „128 GB" eine Zustands-Eigenschaft.
        // .cp bricht um (flex-wrap) — kurze Zusätze (Median 9 Zeichen) stehen
        // neben dem Preis, lange rutschen auf eine eigene Zeile; die Akku-Zeile
        // bleibt unangetastet und die Kachelhöhe folgt dem Grid (stretch).
        var note = pr && pr.note;
        var sub = soldOut || !pr
          ? '<span class="cp">nicht verfügbar</span>' + battLine
          : '<span class="cp">' + (pr.from ? 'ab ' : '') + self.fmt.format(pr.price) +
            (note ? '<span class="cw"><span class="visually-hidden">' + esc(note.title) +
              '</span><span aria-hidden="true">' + esc(note.text) + '</span></span>' : '') +
            '</span>' + battLine;
        html += '<button type="button" class="' + cls + '" data-pre="Zustand_" data-val="' + esc(realVal) +
          '"' + (soldOut ? ' aria-disabled="true"' : '') +
          (note ? ' title="' + esc(note.title) + '"' : '') +
          ' aria-pressed="' + sel + '"><span class="cn">' + esc(label) + '</span>' + sub + '</button>';
      });
      html += '</div>';
      {
        var curCondVal = tagVal(this.cur || {}, 'Zustand_');
        // Label bevorzugt aus der kanonischen Leiter (robust auch wenn der Tag
        // nur "B" ist, z. B. im Nur-Zustand-Modus), sonst aus dem Tag-Text.
        var curGradeEntry = grades.filter(function (g) { return g.key === curGrade; })[0];
        var selLabel = (curGradeEntry && curGradeEntry.label) || condInfo(curCondVal).label;
        // Die Pille „Generalüberholt · geprüft" stand hier bis 12.08.2026. Seit der
        // Zustand als Sub-Span im H1 steht, war sie auf einem Bildschirm die dritte
        // Nennung derselben Aussage — nach dem Titel und der markierten Stufenkachel
        // direkt darüber. Geblieben ist die Verfügbarkeit: die sagt etwas Eigenes —
        // aber nur, wenn sie stimmt. Bei ausverkauftem Produkt entfällt die Zeile
        // ganz (die Kachel sagt „nicht verfügbar", der Kaufbereich sagt den Rest).
        if (curCondVal && curGrade !== 'Neuware' && this.cur && this.cur.availableForSale) {
          html += '<div class="tp-pdp__refurb">' +
            '<span class="tp-pdp__avail">✓ Zustand <b>' + esc(selLabel) + '</b> sofort verfügbar.</span></div>';
        }
        html += '</div>';
      }

      // -- Stufe 2 · Speicher (Upstream: Zustand) + Stufe 3 · Farbe (Upstream:
      //    Zustand + Speicher). Greying reflektiert die aktuelle Auswahl. --
      if (colors.length || storages.length) {
        html += '<div class="tp-pdp__opts">';
        if (storages.length) {
          var curStore = tagVal(this.cur || {}, 'Speicher_');
          html += '<div class="tp-vs__group"><div class="lbl tp-vs__lbl">Speicher</div>' +
            '<div class="tp-pdp__stores">';
          storages.forEach(function (v) {
            var m = self.optMeta('Speicher_', v, self.upstreamOf('Speicher_'));
            var sel = eqVal(v, curStore);
            var alt = (m.soldOut && !sel) ? self.altHint('Speicher_', v) : null;
            var off = m.soldOut && !sel && !alt; // wirklich nirgends verfügbar
            var cls = 'tp-pdp__store' + (sel ? ' is-on' : '') + (off ? ' is-off' : '') + (alt ? ' is-alt' : '');
            var disp = storageLabel(v); // "256" -> "256 GB"; "1 TB" bleibt
            html += '<button type="button" class="' + cls + '" data-pre="Speicher_" data-val="' + esc(v) +
              '"' + (off ? ' aria-disabled="true" title="Nicht verfügbar"' : '') +
              (alt ? ' title="' + esc(disp + ' · ' + alt.why) + '"' : '') +
              ' aria-pressed="' + sel + '">' + esc(disp) +
              (off ? '<span class="tp-vs__delta tp-vs__delta--out">n. verfügbar</span>' : '') +
              '</button>';
          });
          html += '</div></div>';
        }
        if (colors.length) {
          var curColor = tagVal(this.cur || {}, 'Farbe_');
          // Label-Regel (Basisfarbe nur bei Eindeutigkeit) liegt in
          // colorLabelOf() — dieselbe Quelle, die auch der Abweichungs-Zusatz
          // auf den Zustands-Kacheln benutzt.
          var labelOf = function (v) { return self.colorLabelOf(v); };
          var curLabel = labelOf(curColor);
          html += '<div class="tp-vs__group"><div class="lbl tp-vs__lbl">Farbe · <b class="tp-vs__colorname" data-default="' +
            esc(curLabel || '–') + '">' + esc(curLabel || '–') + '</b></div>' +
            '<div class="tp-pdp__swatches">';
          colors.forEach(function (v) {
            var m = self.optMeta('Farbe_', v, self.upstreamOf('Farbe_'));
            var sel = eqVal(v, curColor);
            var alt = (m.soldOut && !sel) ? self.altHint('Farbe_', v) : null;
            var off = m.soldOut && !sel && !alt;
            var cls = 'tp-pdp__swatch' + (sel ? ' is-on' : '') + (off ? ' is-off' : '') + (alt ? ' is-alt' : '');
            var label = labelOf(v);
            // Marketing-Name als Zusatz, wenn das Label die Basisfarbe zeigt
            // ("Rot (PRODUCT RED)") -> Information geht nicht verloren.
            var full = label + (eqVal(label, v) ? '' : ' (' + v + ')');
            var title = full + (off ? ' · nicht verfügbar' : (alt && alt.why ? ' · ' + alt.why : ''));
            // In der Überschrift steht nur der NAME (sie ist versal + gesperrt,
            // ein Hinweis würde sie sprengen); der Grund lebt im Tooltip.
            html += '<button type="button" class="' + cls + '" data-pre="Farbe_" data-val="' + esc(v) +
              '" data-name="' + esc(full) + '" style="background:' + colorHex(v, baseColorOf(self.products, v)) +
              '" title="' + esc(title) + '" aria-label="Farbe ' + esc(title) + '"' +
              (off ? ' aria-disabled="true"' : '') + ' aria-pressed="' + sel + '"></button>';
          });
          html += '</div></div>';
        }
        html += '</div>';
      }

      html += '</div>';
      this.innerHTML = html;

      // Klick-Delegation: nur kombinierbare (nicht is-off) Kacheln/Kreise lösen
      // einen Redirect aus. Ausgegraute Optionen sind inert (kein heimliches Reset).
      // Der bereits gewählte Wert (aria-pressed) ist ebenfalls inert: seine
      // Kachel zeigt den Preis DIESES Geräts. In Familien ohne Speicher-/Farb-
      // Tags (z. B. Smartwatches) fand resolveTarget() sonst irgendein anderes,
      // günstigeres Geschwister desselben Zustands — der Klick auf „ich bin
      // schon hier" hätte den Preis unter der Hand geändert.
      this.addEventListener('click', function (ev) {
        var el = ev.target.closest('[data-pre]');
        if (!el || !this.contains(el)) return;
        if (el.classList.contains('is-off') || el.getAttribute('aria-disabled') === 'true') return;
        if (el.getAttribute('aria-pressed') === 'true') return;
        self.go(el.getAttribute('data-pre'), el.getAttribute('data-val'), el);
      });

      // Intent-Prerender: Ziel-PDP schon bei Hover/Touch/Fokus vorab rendern —
      // nur für kombinierbare Optionen (ausgegraute führen nirgendwo hin).
      var onIntent = function (ev) {
        var el = ev.target.closest && ev.target.closest('[data-pre]');
        if (!el || !this.contains(el)) return;
        if (el.classList.contains('is-off') || el.getAttribute('aria-disabled') === 'true') return;
        if (el.getAttribute('aria-pressed') === 'true') return; // führt nirgendwo hin
        self.speculate(el.getAttribute('data-pre'), el.getAttribute('data-val'));
      };
      this.addEventListener('pointerenter', onIntent, true); // Hover (Desktop)
      this.addEventListener('touchstart', onIntent, { capture: true, passive: true }); // Tap-Start (Mobile)
      this.addEventListener('focusin', onIntent); // Tastatur

      // Farbname in der Label-Zeile mitführen: ein Kreis allein sagt nicht, ob
      // "Graphit" oder "Space Grau" gemeint ist. Hover/Fokus schreibt den Namen
      // (inkl. Verfügbarkeits-Hinweis) in die Überschrift, Verlassen setzt auf
      // die aktuelle Farbe zurück. Touch: der Name steht im title/aria-label.
      var nameEl = this.querySelector('.tp-vs__colorname');
      if (nameEl) {
        var showName = function (ev) {
          var el = ev.target.closest && ev.target.closest('.tp-pdp__swatch[data-name]');
          nameEl.textContent = el ? el.getAttribute('data-name') : nameEl.getAttribute('data-default');
        };
        this.addEventListener('pointerover', showName);
        this.addEventListener('focusin', showName);
        this.addEventListener('pointerleave', function () { nameEl.textContent = nameEl.getAttribute('data-default'); });
        this.addEventListener('focusout', function () { nameEl.textContent = nameEl.getAttribute('data-default'); });
      }
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  customElements.define('tp-variant-selector-v2', TpVariantSelectorV2);
})();
